import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./components/Login";
import Home from "./components/Home";
import ApproveIndividualCandidates from "./components/ApproveIndividualCandidates";
import ApproveCorporateCandidates from "./components/ApproveCorporateCandidates";
import ActiveUsers from "./components/ActiveUsers";
import CandidateSchedules from "./components/CandidateSchedules";
import Header from "./components/Header";
import "./App.css";
import ApproveCandidateInterest from "./components/ApproveCandidateInterest";
import ApproveProfileUpdates from "./components/ApproveProfileUpdates";
import { AllNotificationsPage } from "./components/AllNotificationsPage";
import CareerJourneyFlow from "./components/career_journey/CareerJourneyFlow";
import CandidateProfileEditPage from "./components/candidate_profile_edit/CandidateProfileEditPage";

import { NotificationProvider } from "./components/NotificationContext";
// import { ToastContainer } from "react-toastify";
import toast, { Toaster } from "react-hot-toast";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    const userData = localStorage.getItem("adminUser");

    if (token && userData) {
      try {
        const parsedUser = JSON.parse(userData);
        if (parsedUser.userType === "equally") {
          setIsAuthenticated(true);
          setUser(parsedUser);
        }
      } catch (error) {
        localStorage.removeItem("adminToken");
        localStorage.removeItem("adminUser");
      }
    }
    setLoading(false);
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("adminToken", token);
    localStorage.setItem("adminUser", JSON.stringify(userData));
    setIsAuthenticated(true);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser");
    setIsAuthenticated(false);
    setUser(null);
  };

  if (loading) return <div>Loading...</div>;

  const token = localStorage.getItem("adminToken");
  const userRole = user?.userType || "admin";

  return (
    <Router>
      <div className="App">
        {isAuthenticated ? (
          <NotificationProvider token={token} userRole={userRole}>
            {/* <ToastContainer /> */}
            <Toaster reverseOrder={false} />
            <Header user={user} onLogout={logout} />
            <Routes>
              <Route path="/login" element={<Navigate to="/" replace />} />
              <Route path="/" element={<Home />} />
              <Route
                path="/approve-individual"
                element={<ApproveIndividualCandidates />}
              />
              <Route
                path="/approve-corporate"
                element={<ApproveCorporateCandidates />}
              />
              <Route path="/active-users" element={<ActiveUsers />} />
              <Route
                path="/approve-interest"
                element={<ApproveCandidateInterest />}
              />
              <Route
                path="/candidate-schedules"
                element={<CandidateSchedules />}
              />
              <Route
                path="/approve-profile-updates"
                element={<ApproveProfileUpdates />}
              />
              <Route
                path="/career-journey/:userId"
                element={<CareerJourneyFlow />}
              />
              <Route
                path="/candidate-profile-edit/:userId"
                element={<CandidateProfileEditPage />}
              />
              <Route path="/notifications" element={<AllNotificationsPage />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </NotificationProvider>
        ) : (
          <Routes>
            <Route path="/login" element={<Login onLogin={login} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
